<template>
  <div class="animated fadeIn">
    <div class="timestamp">You • {{time}}</div>
    <div id="user" class="row">
      <!-- <div class="col-sm-3 px-3"> -->
      <div class="ml-n3 mr-2">
        <!-- <img class="avatarL" src="@/assets/Bot.png" alt /> -->
      </div>
      <!-- </div> -->
      <!-- <div class="col-sm-9 p-0"> -->
      <div class="p-0 col-9 mr-2">
        <div class="botCard mx-3">
          <!-- <img src="@/assets/larsenLogo.png" alt=""> -->
          <p class="d-inline-block treatNewLine">{{res.msg}}</p>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "user",
  props: ["res"],
  mounted() {
    // console.log(this.formatAMPM(this.res.time));
  },
  data() {
    return {
      time: this.formatAMPM(this.res.time)
    };
  },
  methods: {
    formatAMPM(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    }
  }
};
</script>

<style scoped>
/* #user p {
  background-color: #b6ddff;
  padding: 5px 25px 7px 12px;
  margin: 5px 15px 5px 5px;
  border-radius: 19px;
  max-width: 220px;
  font-size: 0.85rem;
  /*box-shadow: 0 0 0.75rem rgba(0, 0, 0, .16)!important;*/
/*-webkit-box-shadow: 0 0 0.75rem rgba(0, 0, 0, .16)!important;*/
.eip-link {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  background-color: #ffffff;
  cursor: pointer;
  border: solid 1px #0e5d84;
  color: #0e5d84;
  font-size: 15px;
  font-weight: bold;
  outline: none;
  width: 80px;
}
.treatNewLine {
  /* background-color: #b6ddff; */
  padding: 0px 2px 0px 2px;
  margin: 4px;
  border-radius: 6px;
  font-size: 0.85rem;
  text-align: justify;
  font-size: 13px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  white-space: pre-line;
  word-break: break-word;
}
#user .botCard {
  border-radius: 19px;
  padding: 5px 0px 7px 0px;
  background-color: #b6ddff;
  width: auto;
  float: right;
}
#user .avatarL {
  align-items: center;
  text-align: center;
  font-size: 0.7em;
  line-height: 1.6em;
  width: 30px;
  height: 30px;
  -webkit-box-flex: 0;
  flex-grow: 0;
  margin: 7px 1rem 0px 2px;
}
#user {
  display: flex;
  flex-direction: row-reverse;
}
#user span {
  font-size: 12px;
}
.timestamp {
  text-align: right;
  margin-right: 16px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 14px;
  color: #a5a5a5;
}
</style>


